import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import Header2 from './Header2'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView column center w="100%" h="100%" mt="-20px">
            <CFView column center>
              <CFImage
                w="320px"
                src={heroText}
                alt="Sushi Giwa Japanese Restaurant hero text"
                zIndex={98}
              />
            </CFView>
            <CFView textCenter pulsate mt="20px">
              <OrderPickupButton />
            </CFView>
          </CFView>
          <Header2 />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) bottom/ cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView column center h="100%" mt="-30px">
            <CFImage
              w="400px"
              src={heroText}
              alt="Sushi Giwa Japanese Restaurant hero text"
              zIndex={98}
            />
            <CFView pulsate mt="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
          <Header2 />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
